import { Component, Prop, Vue } from 'vue-property-decorator';
import { RetailerLocation } from '@andromeda/shopping-cart-data-access-store';

@Component({
})

export default class RetailerPickerList extends Vue {
    @Prop({ required: true }) location!: RetailerLocation;

    @Prop({ required: true }) selected!: boolean;

    @Prop({ required: true }) selectedRetailer!: RetailerLocation;

    onSelected(e: Event) {
        const isSelected = this.selected;
        let isLocation = this.location;
        if (isSelected) {
            isLocation = this.selectedRetailer;
        }
        this.$emit('locationSelected', isLocation);
    }
}
